<template>
  <document-registry-page
    fixed-document-type="act_sver"
    page-title="Акты сверки взаиморасчетов"
    table-title="Сохраненные акты"
    description-text="Сверка взаиморасчетов с контрагентами за выбранный период. Доступ на просмотр не дает права формировать новые акты."
    search-label="Номер или контрагент"
    create-label="Сформировать"
    :single-create-option="createOption"
  />
</template>

<script>
import DocumentRegistryPage from './DocumentRegistryPage.vue'

export default {
  name: 'ReconciliationWorkspace',
  components: { DocumentRegistryPage },
  data() {
    return {
      createOption: {
        key: 'act-sver',
        label: 'Сформировать акт сверки',
        routeName: 'document_create_act_sver'
      }
    }
  }
}
</script>
